// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrendingNow_trendingSection__ulyqr {
  color: white;
  min-height: 100%;
  max-width: 95%;
  width: 100%;
  margin: 0 auto;
}

.TrendingNow_trendingHeader__W-w8g {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.TrendingNow_title__hF7Ni {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.TrendingNow_navigationButtons__GM8vM {
  display: flex;
  gap: 10px;
}

.TrendingNow_navButton__2QgBM {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.TrendingNow_navButton__2QgBM:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.TrendingNow_navButton__2QgBM:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.TrendingNow_swiperContainer__BBnkh {
  margin: 0 auto;
  padding: 0px;
  position: relative;
}

.TrendingNow_swiperWrapper__2QV0m {
  width: 100%;
}

.TrendingNow_swiperSlide__iOrQQ {
  height: auto!important;
}

.TrendingNow_mediaCard__XXBTm {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #2a2a2a;
  height: 100%;
  transition: transform 0.3s ease;
}



.TrendingNow_imageWrapper__nbF6\\+ {
  position: relative;
  width: 100%;
  height: auto; /* Fixed height for consistency */
  max-height: 450px;
  overflow: hidden;
}

.TrendingNow_mediaImage__x9hg- {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}



.TrendingNow_overlay__YFGBj {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.TrendingNow_mediaLabel__4GsTu {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.TrendingNow_labelText__pNsbU {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  
}

.TrendingNow_playButton__y\\+wyn {
  position: absolute;
  right: 10px;
  bottom: 50px;
  background: rgba(255, 0, 0, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
  opacity: 0;
  transform: scale(0.8);
}





.TrendingNow_mediaInfo__QlS8Z {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: rgb(152 147 147 / 40%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.TrendingNow_mediaTitle__IXDod {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 10px 0;
  line-height: 1.2;
  color: white;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: nowrap;        /* Prevents text from wrapping */
  overflow: hidden;           /* Hides the overflow */
  text-overflow: ellipsis;    /* Adds ... */
  display: inline-block;      /* Ensures block behavior for truncation */
  max-width: 90%; 
}

.TrendingNow_mediaDetails__EsG75 {
  display: flex;
  gap: 8px;
}

.TrendingNow_detailBadge__dmuej {
  border-radius: 4px;
  font-size: 10px;
  color: white;
  font-weight: bold;
}

@media (max-width: 1024px) {
  .TrendingNow_imageWrapper__nbF6\\+ {
    height: auto;
  }
  
  .TrendingNow_title__hF7Ni {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .TrendingNow_imageWrapper__nbF6\\+ {
    height: auto;
  }

  .TrendingNow_trendingHeader__W-w8g {
    margin-bottom: 15px;
  }
  
  .TrendingNow_navButton__2QgBM {
    width: 36px;
    height: 36px;
  }
  
  .TrendingNow_mediaTitle__IXDod {
    font-size: 14px;
    margin-bottom: 6px;
  }
  
  .TrendingNow_mediaInfo__QlS8Z {
    padding: 12px;
  }
  
  .TrendingNow_detailBadge__dmuej {
    padding: 3px 6px;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .TrendingNow_imageWrapper__nbF6\\+ {
    height: auto;
  }
  .TrendingNow_trendingSection__ulyqr{
    padding: 0;
    margin: 0 auto;
  }
  
  .TrendingNow_title__hF7Ni {
    font-size: 18px;
  }
  
  .TrendingNow_mediaTitle__IXDod {
    font-size: 10px;
    margin-bottom: 0px;
    -webkit-line-clamp: 1;
  }
  .TrendingNow_mediaDetails__EsG75{
    gap: 2px;
    display: none;
  }
  
  .TrendingNow_mediaInfo__QlS8Z {
    padding: 8px;
  }
  
  .TrendingNow_playButton__y\\+wyn {
    opacity: 1;
    transform: scale(1);
    width: 25px;
    height: 25px;
    right: 5px;
    bottom: 45px;
  }
  
  .TrendingNow_mediaLabel__4GsTu {
    top: 5px;
    right: 5px;
  }
  
  .TrendingNow_labelText__pNsbU {
    padding: 3px 6px;
    font-size: 10px;
   

  }
  
  .TrendingNow_detailBadge__dmuej {
    font-size: 9px;
    padding: 2px 4px;
  }
  .TrendingNow_trendingHeader__W-w8g {
    margin-bottom: 0px;
  }
  .TrendingNow_mediaCard__XXBTm{
    height: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/TrendingNow.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,iCAAiC;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,qBAAqB;AACvB;;;;;;AAMA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB,SAAS,gCAAgC;EAC5D,gBAAgB,YAAY,uBAAuB;EACnD,uBAAuB,KAAK,aAAa;EACzC,qBAAqB,OAAO,0CAA0C;EACtE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;;;EAGjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".trendingSection {\n  color: white;\n  min-height: 100%;\n  max-width: 95%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.trendingHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.navigationButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.navButton {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: white;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.navButton:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.navButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.swiperContainer {\n  margin: 0 auto;\n  padding: 0px;\n  position: relative;\n}\n\n.swiperWrapper {\n  width: 100%;\n}\n\n.swiperSlide {\n  height: auto!important;\n}\n\n.mediaCard {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #2a2a2a;\n  height: 100%;\n  transition: transform 0.3s ease;\n}\n\n\n\n.imageWrapper {\n  position: relative;\n  width: 100%;\n  height: auto; /* Fixed height for consistency */\n  max-height: 450px;\n  overflow: hidden;\n}\n\n.mediaImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n\n.mediaLabel {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 2;\n}\n\n.labelText {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  padding: 6px 12px;\n  border-radius: 15px;\n  font-size: 12px;\n  font-weight: 500;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  cursor: pointer;\n  \n}\n\n.playButton {\n  position: absolute;\n  right: 10px;\n  bottom: 50px;\n  background: rgba(255, 0, 0, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 2;\n  opacity: 0;\n  transform: scale(0.8);\n}\n\n\n\n\n\n.mediaInfo {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  background: rgb(152 147 147 / 40%);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mediaTitle {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n  line-height: 1.2;\n  color: white;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: nowrap;        /* Prevents text from wrapping */\n  overflow: hidden;           /* Hides the overflow */\n  text-overflow: ellipsis;    /* Adds ... */\n  display: inline-block;      /* Ensures block behavior for truncation */\n  max-width: 90%; \n}\n\n.mediaDetails {\n  display: flex;\n  gap: 8px;\n}\n\n.detailBadge {\n  border-radius: 4px;\n  font-size: 10px;\n  color: white;\n  font-weight: bold;\n}\n\n@media (max-width: 1024px) {\n  .imageWrapper {\n    height: auto;\n  }\n  \n  .title {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .imageWrapper {\n    height: auto;\n  }\n\n  .trendingHeader {\n    margin-bottom: 15px;\n  }\n  \n  .navButton {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .mediaTitle {\n    font-size: 14px;\n    margin-bottom: 6px;\n  }\n  \n  .mediaInfo {\n    padding: 12px;\n  }\n  \n  .detailBadge {\n    padding: 3px 6px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .imageWrapper {\n    height: auto;\n  }\n  .trendingSection{\n    padding: 0;\n    margin: 0 auto;\n  }\n  \n  .title {\n    font-size: 18px;\n  }\n  \n  .mediaTitle {\n    font-size: 10px;\n    margin-bottom: 0px;\n    -webkit-line-clamp: 1;\n  }\n  .mediaDetails{\n    gap: 2px;\n    display: none;\n  }\n  \n  .mediaInfo {\n    padding: 8px;\n  }\n  \n  .playButton {\n    opacity: 1;\n    transform: scale(1);\n    width: 25px;\n    height: 25px;\n    right: 5px;\n    bottom: 45px;\n  }\n  \n  .mediaLabel {\n    top: 5px;\n    right: 5px;\n  }\n  \n  .labelText {\n    padding: 3px 6px;\n    font-size: 10px;\n   \n\n  }\n  \n  .detailBadge {\n    font-size: 9px;\n    padding: 2px 4px;\n  }\n  .trendingHeader {\n    margin-bottom: 0px;\n  }\n  .mediaCard{\n    height: 180px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trendingSection": `TrendingNow_trendingSection__ulyqr`,
	"trendingHeader": `TrendingNow_trendingHeader__W-w8g`,
	"title": `TrendingNow_title__hF7Ni`,
	"navigationButtons": `TrendingNow_navigationButtons__GM8vM`,
	"navButton": `TrendingNow_navButton__2QgBM`,
	"swiperContainer": `TrendingNow_swiperContainer__BBnkh`,
	"swiperWrapper": `TrendingNow_swiperWrapper__2QV0m`,
	"swiperSlide": `TrendingNow_swiperSlide__iOrQQ`,
	"mediaCard": `TrendingNow_mediaCard__XXBTm`,
	"imageWrapper": `TrendingNow_imageWrapper__nbF6+`,
	"mediaImage": `TrendingNow_mediaImage__x9hg-`,
	"overlay": `TrendingNow_overlay__YFGBj`,
	"mediaLabel": `TrendingNow_mediaLabel__4GsTu`,
	"labelText": `TrendingNow_labelText__pNsbU`,
	"playButton": `TrendingNow_playButton__y+wyn`,
	"mediaInfo": `TrendingNow_mediaInfo__QlS8Z`,
	"mediaTitle": `TrendingNow_mediaTitle__IXDod`,
	"mediaDetails": `TrendingNow_mediaDetails__EsG75`,
	"detailBadge": `TrendingNow_detailBadge__dmuej`
};
export default ___CSS_LOADER_EXPORT___;
